import React, { useRef } from 'react';
import { Box } from '@mui/material';
import { sxStyles } from './StepProcess.styles';
import { colors, fontWeight, Icons, Text, textLevel } from '../../packages';

const getStatusIcon = (status, isSubStep) => {
  if (status === 'success') {
    return (
      <Box sx={{ ...sxStyles.statusIconBase(isSubStep), ...sxStyles.statusIconCompleted(isSubStep) }}>
        {!isSubStep && <Icons glyph="checkmark" color={colors.success600} />}
      </Box>
    );
  } else if (status === 'in_progress') {
    return (
      <Box sx={{ ...sxStyles.statusIconBase(isSubStep), ...sxStyles.statusIconInProgress }}>
        {!isSubStep && <Icons glyph="chevron-right" color={colors.white} />}
      </Box>
    );
  } else if (status === 'invalid') {
    return (
      <Box sx={{ ...sxStyles.invalidStatusIconBase(isSubStep), ...sxStyles.statusIconInvalid }}>
        {!isSubStep && <Icons glyph="info" color={colors.warning600} />}
      </Box>
    );
  } else {
    return (
      <Box sx={{ ...sxStyles.statusIconBase(isSubStep), ...sxStyles.statusIconError }}>
        {!isSubStep && <Icons glyph="close" color={colors.white} />}
      </Box>
    );
  }
};

const getStatusText = status => {
  if (status === 'success') {
    return 'Completed';
  } else if (status === 'in_progress') {
    return 'In progress';
  } else if (status === 'invalid') {
    return 'Invalid';
  } else {
    return 'Error';
  }
};

const StepItem = ({ step, isLastStep, isLastSubStep }) => {
  const heightRef = useRef(null);
  return (
    <Box sx={sxStyles.stepItems} ref={heightRef}>
      <Box sx={sxStyles.stepMain}>
        <Box sx={sxStyles.stepIconContainer(false)}>
          {!isLastStep && <Box sx={sxStyles.connectingLine(heightRef.current?.clientHeight)} />}
        </Box>
        <Box sx={sxStyles.stepText}>
          {getStatusIcon(step.status === 'error' ? 'error' : isLastStep ? step.status : 'success', false)}
          <Text level={textLevel.S} weight={fontWeight.BOLD} color={colors.neutral900} sx={sxStyles.message}>
            {step.message}
          </Text>
          <Text level={textLevel.S} weight={fontWeight.MEDIUM} color={colors.neutral500}>
            {getStatusText(step.status === 'error' ? 'Error' : isLastStep ? step.status : 'success')}
          </Text>
        </Box>
      </Box>
      {step.subSteps?.map((subStep, subIndex) => {
        return (
          <SubItem
            key={subIndex}
            subStep={subStep}
            subIndex={subIndex}
            subSteps={step.subSteps}
            isLastStep={isLastStep}
            isLastSubStep={isLastSubStep(subIndex)}
          />
        );
      })}
    </Box>
  );
};

const SubItem = ({ subStep, isLastSubStep }) => {
  const heightRef = useRef(null);
  return (
    <Box sx={sxStyles.subStepItems}>
      <Box sx={sxStyles.stepMain} ref={heightRef}>
        <Box sx={sxStyles.stepIconContainer(true)}>
          {!isLastSubStep && <Box sx={sxStyles.connectingLine(heightRef.current?.clientHeight)} />}
        </Box>
        <Box sx={sxStyles.stepText}>
          {getStatusIcon(
            subStep.subStepStatus === 'error' ? 'error' : isLastSubStep ? subStep.subStepStatus : 'success',
            true,
          )}
          <Text
            level={textLevel.S}
            weight={fontWeight.MEDIUM}
            color={colors.neutral700}
            sx={sxStyles.message}
          >
            {subStep.subStepMessage}
          </Text>
          <Text level={textLevel.XS} weight={fontWeight.MEDIUM} color={colors.neutral500}>
            {getStatusText(
              subStep.subStepStatus === 'error' ? 'Error' : isLastSubStep ? subStep.subStepStatus : 'success',
            )}
          </Text>
        </Box>
      </Box>
    </Box>
  );
};

export default StepItem;
